function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';
import Input from 'components/Form/Input';
import intlShape from 'shapes/intlShape';
var _React_PureComponent;
class Switch extends (_React_PureComponent = React.PureComponent) {
    get isOn() {
        const value = get(this.props.formValues, [
            'values',
            this.props.id
        ]);
        return value === this.props.inputValue;
    }
    renderLabel() {
        const { intl, labelMessage, labelMessageValues } = this.props;
        let label = null;
        if (labelMessage) {
            label = intl.formatMessage(labelMessage, labelMessageValues);
        }
        if (!label) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "switch__label",
            children: label
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("label", {
            className: cn('switch-group', {
                'switch-group--on': this.isOn,
                'switch-group--disabled': this.props.isDisabled
            }),
            htmlFor: this.props.id,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn('switch', {
                        'switch--on': this.isOn,
                        'switch--disabled': this.props.isDisabled
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(Input, {
                            id: this.props.id,
                            type: "checkbox",
                            value: this.props.inputValue,
                            formControl: false,
                            onChange: this.props.onChange,
                            isDisabled: this.props.isDisabled
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "switch__slider"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "switch__label",
                    children: this.renderLabel()
                })
            ]
        });
    }
}
_define_property(Switch, "propTypes", {
    // Explicit props
    id: PropTypes.string.isRequired,
    inputValue: PropTypes.string.isRequired,
    formValues: PropTypes.object,
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    labelMessageValues: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    // Implicit props
    intl: intlShape.isRequired
});
export default injectIntl(Switch);
